import { supabase } from './supabase';

export const employeeNameToUserId: Record<string, string> = {
  'Elma Dumasig': 'user-id-1',
  'Cristy Cericos': 'user-id-2',
  // Add all employee mappings
};

export const fetchUserIdByName = async (displayName: string) => {
  try {
    console.log('Fetching user ID for:', displayName); // Debug log
    const { data, error } = await supabase
      .from('user_profiles')
      .select('user_id')
      .eq('display_name', displayName)
      .single();

    if (error) {
      console.error('Error fetching user ID:', error); // Debug log
      throw error;
    }
    
    console.log('Found user ID:', data?.user_id); // Debug log
    return data?.user_id;
  } catch (error) {
    console.error('Error fetching user ID:', error);
    return null;
  }
}; 